(function () {
  'use strict';

  var KEY = 'halamama_wishlist';

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* Talk to localStorage directly rather than waiting for wishlist.js to define
     window.WishlistStorage. Same key, same shape — so the heart buttons, the
     wishlist page and this carousel all stay in agreement even if the other
     script has not finished loading yet. */
  var Store = {
    writeAll: function (list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    },
    getAll: function () {
      if (window.WishlistStorage && typeof window.WishlistStorage.getAll === 'function') {
        try { return window.WishlistStorage.getAll() || []; } catch (e) {}
      }
      try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
    },
    remove: function (id) {
      if (window.WishlistStorage && typeof window.WishlistStorage.remove === 'function') {
        try { return window.WishlistStorage.remove(id); } catch (e) {}
      }
      try {
        var list = (JSON.parse(localStorage.getItem(KEY)) || []).filter(function (p) {
          return String(p.id) !== String(id);
        });
        localStorage.setItem(KEY, JSON.stringify(list));
        return list;
      } catch (e) { return []; }
    }
  };

  function notifyWishlist() {
    if (window.WishlistUI) {
      try {
        if (window.WishlistUI.updateBadge) window.WishlistUI.updateBadge();
        if (window.WishlistUI.updateAllButtons) window.WishlistUI.updateAllButtons();
      } catch (e) {}
    }
    try { new BroadcastChannel(KEY).postMessage('changed'); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:updated', { bubbles: true }));
  }

  /* Mirrors the private _refreshCartDrawer in wishlist.js — that one is not
     exported, so the same section-rendering call is repeated here. */
  function refreshCart() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble,cart-icon-quick')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parser = new DOMParser();
        var cartDrawerEl = document.querySelector('cart-drawer');
        var drawerInner = document.getElementById('CartDrawer');

        if (drawerInner && sections['cart-drawer']) {
          var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
          var newInner = doc.querySelector('#CartDrawer');
          var newDrawer = doc.querySelector('cart-drawer');
          if (newInner) {
            drawerInner.innerHTML = newInner.innerHTML;
            if (cartDrawerEl && newDrawer) {
              cartDrawerEl.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
            }
          }
        }

        ['cart-icon-bubble', 'cart-icon-quick'].forEach(function (name) {
          if (!sections[name]) return;
          var d = parser.parseFromString(sections[name], 'text/html');
          var fresh = d.querySelector('#' + name);
          if (!fresh) return;
          document.querySelectorAll('#' + name).forEach(function (el) {
            el.innerHTML = fresh.innerHTML;
          });
        });

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
        if (cartDrawerEl && typeof cartDrawerEl.open === 'function') cartDrawerEl.open();
      })
      .catch(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('.cart-count-bubble span, [data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          })
          .catch(function () {});
      });
  }

  /* Swap the cart section's markup in place. cart-redesign.js re-binds itself
     from the fresh DOM, so its handlers survive the replacement. */
  function refreshCartSection() {
    var section = document.querySelector('[data-cr]');
    if (!section) return Promise.resolve();
    var id = section.getAttribute('data-section-id');
    if (!id) return Promise.resolve();

    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cr]');
        var wrapper = section.parentNode;
        if (!fresh || !wrapper) return;
        section.replaceWith(fresh);
        document.dispatchEvent(new CustomEvent('cart:section-refreshed', { bubbles: true }));
      })
      .catch(function () {});
  }

  /* Older wishlist entries were saved without a variantId. Recover it from the
     product JSON instead of failing the click. */
  function resolveVariant(handle, known) {
    if (known && known !== 'undefined' && known !== 'null' && known !== '') {
      return Promise.resolve(known);
    }
    if (!handle) return Promise.resolve(null);
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) return null;
        var available = p.variants.filter(function (v) { return v.available; });
        return String((available[0] || p.variants[0]).id);
      })
      .catch(function () { return null; });
  }

  function init(root) {
    if (root.dataset.wlcReady === '1') return;
    root.dataset.wlcReady = '1';

    var body = root.querySelector('[data-wlc-body]');
    var empty = root.querySelector('[data-wlc-empty]');
    var limit = parseInt(root.getAttribute('data-wlc-limit') || '12', 10);
    var hideEmpty = root.getAttribute('data-wlc-hide-empty') === 'true';
    var T_ATC = root.getAttribute('data-wlc-atc') || 'Add to cart';
    var T_RM = root.getAttribute('data-wlc-remove') || 'Remove';
    var T_ADDED = root.getAttribute('data-wlc-added') || 'Added';
    var T_OOS = root.getAttribute('data-wlc-oos') || 'Out of stock';
    var stock = {};

    function loadStock(handle) {
      if (!stock[handle]) {
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        stock[handle] = fetch(base + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      }
      return stock[handle];
    }

    function checkStock() {
      root.querySelectorAll('[data-wlc-item]').forEach(function (card) {
        if (card.hasAttribute('data-wlc-stock')) return;
        var handle = card.getAttribute('data-wlc-handle');
        var btn = card.querySelector('[data-wlc-atc]');
        if (!handle || !btn) return;
        card.setAttribute('data-wlc-stock', '');
        loadStock(handle).then(function (p) {
          if (!p || !p.variants) return;
          var vid = String(btn.getAttribute('data-variant-id') || '');
          var v = null;
          for (var i = 0; i < p.variants.length; i++) {
            if (String(p.variants[i].id) === vid) { v = p.variants[i]; break; }
          }
          var inStock = v ? v.available : p.available;
          if (inStock || !btn.isConnected) return;
          var oos = document.createElement('button');
          oos.type = 'button';
          oos.className = 'wlc__btn wlc__btn--oos';
          oos.disabled = true;
          oos.textContent = T_OOS;
          btn.parentNode.replaceChild(oos, btn);
          card.classList.add('is--oos');
        });
      });
    }

    function cardHTML(p, idx) {
      var variant = p.variantTitle && p.variantTitle !== 'Default Title'
        ? '<p class="wlc__variant">' + esc(p.variantTitle) + '</p>'
        : '';
      var img = p.image
        ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" width="320" height="320">'
        : '';
      return '' +
        '<article class="wlc__card" data-wlc-item data-wlc-index="' + idx + '" data-wlc-id="' + esc(p.id) + '" data-wlc-handle="' + esc(p.handle) + '">' +
          '<div class="wlc__mediawrap">' +
            '<a class="wlc__media" href="/products/' + esc(p.handle) + '">' + img + '</a>' +
          '</div>' +
          '<div class="wlc__info">' +
            '<a class="wlc__name" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a>' +
            variant +
            '<p class="wlc__price" data-wl-price data-handle="' + esc(p.handle) + '" data-variant="' + esc(String(p.variantId || '')) + '">' + esc(p.price) + '</p>' +
            '<div class="wlc__actions">' +
              '<button type="button" class="wlc__btn wlc__btn--atc" data-wlc-atc data-variant-id="' + esc(p.variantId) + '">' + esc(T_ATC) + '</button>' +
            '</div>' +
          '</div>' +
        '</article>';
    }

    var rendered = [];
    function render() {
      var list = Store.getAll();
      rendered = list.slice();
      if (limit > 0) list = list.slice(0, limit);

      if (!list.length) {
        if (body) body.innerHTML = '';
        if (hideEmpty) {
          root.hidden = true;
        } else {
          root.hidden = false;
          if (empty) empty.hidden = false;
        }
        return;
      }

      root.hidden = false;
      if (empty) empty.hidden = true;
      if (body) {
        body.innerHTML =
          '<button type="button" class="wlc__nav wlc__nav--prev" data-wlc-prev aria-label="Previous">' +
            '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>' +
          '</button>' +
          '<div class="wlc__track" data-wlc-track>' + list.map(function (p, i) { return cardHTML(p, i); }).join('') + '</div>' +
          '<button type="button" class="wlc__nav wlc__nav--next" data-wlc-next aria-label="Next">' +
            '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>' +
          '</button>';
        bindNav();
        checkStock();
      }
    }

    /* Native scroll with buttons, matching the featured-collection carousel:
       one card width per click, arrows disable at each end. */
    function bindNav() {
      var track = root.querySelector('[data-wlc-track]');
      var prev = root.querySelector('[data-wlc-prev]');
      var next = root.querySelector('[data-wlc-next]');
      if (!track || !prev || !next) return;

      var rtl = getComputedStyle(track).direction === 'rtl';

      function step() {
        var card = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap || '16') || 16;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      }
      function go(dir) {
        track.scrollBy({ left: step() * dir * (rtl ? -1 : 1), behavior: 'smooth' });
      }
      function refresh() {
        var max = track.scrollWidth - track.clientWidth - 1;
        var pos = Math.abs(track.scrollLeft);
        prev.disabled = pos <= 0;
        next.disabled = pos >= max;
        var hide = max <= 0;
        prev.hidden = hide;
        next.hidden = hide;
      }

      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', refresh, { passive: true });
      window.addEventListener('resize', refresh);
      requestAnimationFrame(refresh);
    }

    /* Same sequence the wishlist page uses: fade the card, remove from
       storage, refresh the badge and every heart on the page, then re-render.
       No page reload — the header count is updated by WishlistUI, not by
       Liquid. */
    function removeFromStore(el) {
      var id = el.getAttribute('data-wlc-id');
      var idx = parseInt(el.getAttribute('data-wlc-index'), 10);
      if (window.WishlistStorage && typeof window.WishlistStorage.remove === 'function') {
        window.WishlistStorage.remove(id);
      } else {
        var list = Store.getAll();
        if (!isNaN(idx) && idx >= 0 && idx < list.length) {
          list.splice(idx, 1);
        } else {
          list = list.filter(function (p) { return String(p.id) !== String(id); });
        }
        Store.writeAll(list);
      }
    }

    function removeCard(el) {
      el.style.opacity = '0';
      el.style.transform = 'scale(0.9)';

      setTimeout(function () {
        removeFromStore(el);

        if (window.WishlistUI) {
          try {
            window.WishlistUI.updateBadge();
            window.WishlistUI.updateAllButtons();
          } catch (e) {}
        }
        try { new BroadcastChannel(KEY).postMessage('changed'); } catch (e) {}
        render();
      }, 250);
    }

    function addToCart(btn) {
      var el = btn.closest('[data-wlc-item]');
      if (!el) return;

      btn.disabled = true;
      btn.textContent = '…';

      resolveVariant(el.getAttribute('data-wlc-handle'), btn.getAttribute('data-variant-id'))
        .then(function (variantId) {
          if (!variantId) throw new Error('no variant');
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
        })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          btn.textContent = T_ADDED;
          /* Drop it from the wishlist first, then reload: the cart line is
             already saved server-side, so the fresh page shows the product in
             the cart and gone from the carousel in one pass. */
          return refreshCart();
        })
        .then(function () {
          /* The cart page renders its lines server-side, so a drawer refresh
             alone leaves the new product invisible. Re-render just that section
             through the Section Rendering API instead of reloading the page —
             scroll position and the carousel stay put. */
          return refreshCartSection();
        })
        .then(function () {
          setTimeout(function () { removeCard(el); }, 400);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = T_ATC;
        });
    }

    root.addEventListener('click', function (e) {
      var atc = e.target.closest('[data-wlc-atc]');
      if (atc && root.contains(atc)) {
        e.preventDefault();
        e.stopPropagation();
        addToCart(atc);
        return;
      }
      var rm = e.target.closest('[data-wlc-remove]');
      if (rm && root.contains(rm)) {
        e.preventDefault();
        e.stopPropagation();
        var el = rm.closest('[data-wlc-item]');
        if (el) {
          rm.disabled = true;
          rm.classList.remove('is--active');
          removeCard(el);
        }
      }
    });

    window.addEventListener('storage', function (e) {
      if (!e.key || e.key === KEY) render();
    });
    document.addEventListener('wishlist:updated', render);
    /* The cart's bulk "move to wishlist" writes to localStorage and re-renders
       its own section. Same-tab writes never fire the storage event, so listen
       for the cart's own signal too. */
    document.addEventListener('cart:section-refreshed', render);
    document.addEventListener('cart:wishlist-updated', render);
    try { new BroadcastChannel(KEY).onmessage = render; } catch (e) {}

    render();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-wlc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
